import { Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { useStrings } from '../../assets/localization/strings'
import { getCurrencySymbolByCountry } from '../../reusableUtils/currency'
import rootStore from '../../stores/rootStore'
import EmptyIllustration from '../../assets/icons/emptyIllustration.svg'
export const EmptyCampaigns = ({ onCreate }: { onCreate(): void }) => {
  const strings = useStrings()
  const price = 189
  const currencySymbol = rootStore.brandStore.selectedBrand?.brandCountry ? getCurrencySymbolByCountry(rootStore.brandStore.selectedBrand?.brandCountry) : '€'
  return (
    <Grid
      container
      pt={3}
      pb={3}
      sx={{
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        maxWidth: '1400px',
        minWidth: '1140px'
      }}>
      {/* TODO
      <Grid item container xs={12} justifyContent='center'>
        <Player src={strings.dashboard_empty_tour} width={526} />
      </Grid> 
      */}
      <Grid item xs={16} container justifyContent='center'>
        <img src={EmptyIllustration} alt='illustration'  width={100} />
        <Typography variant='h2' textAlign='center' width='100%' sx={{ fontFamily: 'Bricolage Grotesque', fontSize: '30px', fontWeight: 600, marginTop: '30px' }}>
          {strings.dashboard_empty_title}
        </Typography>
        <Typography
          variant='body1'
          textAlign='center'
          width='100%'
          sx={{ fontSize: '16px', fontWeight: 400, color: '#17181BBF', whiteSpace: 'pre', marginTop: '10px', marginBottom: '30px' }}>
          {currencySymbol === '£' ? strings.dashboard_empty_body(currencySymbol + price, '') : strings.dashboard_empty_body(price, currencySymbol)}
        </Typography>
        <Button
          sx={{ backgroundColor: '#190851', color: '#ffffff', borderRadius: '50px', fontWeight: 600, fontSize: '16px', textTransform: 'none' }}
          variant='contained'
          onClick={onCreate}
          id='CREATE_CAMPAIGN_LINK_TUTORIAL'>
          + {strings.dashboard_create_ugc_button}
        </Button>
      </Grid>
    </Grid>
  )
}
